import type { HomepageStats } from '../../types'

interface TrustedByProps {
  stats: HomepageStats
  companyLogos?: Array<{
    name: string
    logo: string
  }>
}

// Default logos using DiceBear (same as demo data)
const defaultLogos = [
  { name: 'FinTech Solutions', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=fintech' },
  { name: 'TechStartup Ireland', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=techstartup' },
  { name: 'Cloud Services', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=cloudserv' },
  { name: 'CyberSec Ireland', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=cybersec' },
  { name: 'Dublin AI', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=dublinai' },
  { name: 'HealthTech', logo: 'https://api.dicebear.com/7.x/identicon/svg?seed=healthtech' },
]

export function TrustedBy({ stats, companyLogos }: TrustedByProps) {
  const logos = companyLogos && companyLogos.length > 0 ? companyLogos : defaultLogos

  return (
    <section className="py-12 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-medium text-gray-500 uppercase tracking-wide mb-8">
          Trusted by {stats.total_companies}+ companies across Ireland
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {logos.map((company) => (
            <div
              key={company.name}
              className="grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-200"
              title={company.name}
            >
              <img
                src={company.logo}
                alt={company.name}
                className="h-10 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
